import { Component, ElementRef, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import { Dotcom2024Service } from '../../dotcom2024.service';
import { CommonModule, ViewportScroller } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GoogleMapsModule, MapGeocoder } from '@angular/google-maps';
import { Router } from '@angular/router';
import { PhoneNumberPipe } from '../../phone-number.pipe';
import { MyharrellsService } from '../../myharrells.service';

declare var hbspt: any; //for hubspot forms

@Component({
  selector: 'app-findrep',
  standalone: true,
  imports: [CommonModule, FormsModule, GoogleMapsModule, PhoneNumberPipe],
  templateUrl: './findrep.component.html',
  styleUrl: './findrep.component.css'
})
export class FindrepComponent {

  @ViewChild('myCheckbox') myCheckbox: ElementRef;

  constructor(public myHarrellsService: MyharrellsService, private sanitizer: DomSanitizer, private viewportScroller: ViewportScroller, private title: Title, private meta: Meta, public dotComService: Dotcom2024Service, public geocoder: MapGeocoder, public router: Router) {
    this.gc = geocoder;
    geocoder.geocode({
      address: '1600 Amphitheatre Parkway, Mountain View, CA'
    }).subscribe(({ results }) => {
      // console.log(results);
    });

  }

  gc: MapGeocoder;


  optionsDefMap: google.maps.MapOptions = {
    mapId: "Default_MAP_ID",
    center: { lat: 38, lng: -95 },
    zoom: 4,
  };
  // markers used default location
  defMarker: any[] = [];


  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/People/";
  locationsImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Locations/";
  marketsImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Markets/";
  employeePhotosImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Employee-Photos/";

  selectedMarket: string = "";
  selectedState: string = "";
  selectedSort: string = "";
  zipCode: string = "";
  displayFailure: boolean = false;
  failureText: string = "";
  usersLocationdetected: boolean = false;

  repsFilteredList: any[] = [];
  repsFilteredListTotal: any[] = [];
  repSearchText: string = "";
  allStates: any[] = [];
  allSegments: any[] = [];
  checkedSegments: string[] = []; //array of checked segments
  checkedStates: string[] = []; //array of checked states
  selectedWarehouse: any[] = [];
  exploreBy: string = "map"; //default to map

  stateExpanded: boolean = false;
  marketExpanded: boolean = false;

  displayMoreButton: boolean = true;
  repsRecordsInDisplayArray: number = 0;


  firstNameRepMatch: string = "";
  lastNameRepMatch: string = "";
  emailRepMatch: string = "";
  phoneRepMatch: string = "";
  companyRepMatch: string = "";
  cityRepMatch: string = "";
  stateRepMatch: string = "";
  zipRepMatch: string = "";
  titleRepMatch: string = "";
  marketsRepMatch: string = "";
  commentsRepMatch: string = "";
  golfRepMatch: boolean = false;
  lawnCareRepMatch: boolean = false;
  horticultureRepMatch: boolean = false;
  sportsTurfRepMatch: boolean = false;
  specialtyAgRepMatch: boolean = false;

  showFilterObjects: boolean = false;

  ngOnInit() {

    this.dotComService.activePage = "findrep"

    this.showFilterObjects = false;

    //meta tags for SEO
    this.title.setTitle("Find Your Harrell’s Rep | Local Agronomic Support");
    this.meta.updateTag({ name: 'description', content: "Need agronomic solutions? Use our rep locator to find your local Harrell’s account manager by market and zip code. Get expert support today!" });
    this.meta.updateTag({ property: 'og:title', content: "Find Your Harrell’s Rep | Local Agronomic Support" });
    this.meta.updateTag({ property: 'og:description', content: "Need agronomic solutions? Use our rep locator to find your local Harrell’s account manager by market and zip code. Get expert support today!" });
    // this.meta.updateTag({ property: 'og:image', content: "og:image here - find my rep" });
    // this.meta.updateTag({ property: 'og:url', content: "og:url here - find my rep" });
    this.meta.updateTag({ property: 'Twitter:card', content: "Find Your Harrell’s Rep | Local Agronomic Support" });
    this.meta.updateTag({ property: 'Twitter:site', content: "Find Your Harrell’s Rep | Local Agronomic Support" });
    this.meta.updateTag({ property: 'Twitter:title', content: "Find Your Harrell’s Rep | Local Agronomic Support" });
    this.meta.updateTag({ property: 'Twitter:description', content: "Need agronomic solutions? Use our rep locator to find your local Harrell’s account manager by market and zip code. Get expert support today!" });
    // this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here - find my rep" });

    //get the master list of all reps 
    this.GetAllReps();
    this.GetAllStates(); //for the filter
    this.GetAllSegments(); //for the filter
    this.dotComService.GetLocations().then(results => {
      this.dotComService.warehouses = this.dotComService.warehouses.sort((a, b) => (a.name > b.name) ? 1 : -1);

      //add the map markers for the locations to the map 
      this.defMarker = [];
      for (let index = 0; index < this.dotComService.warehouses.length; index++) {
        const element = this.dotComService.warehouses[index];
        this.defMarker.push({ lat: parseFloat(element.latitude), lng: parseFloat(element.longitude), map: this.optionsDefMap, title: element.name, label: { text: element.name, color: 'green' } });
      }

      //the rep detail page passes a query string value if the user used the search feature from the REP DETAIL page
      if (typeof document !== 'undefined') {
        let queryString = document.location.search;
        let urlParams = new URLSearchParams(queryString);
        this.zipCode = urlParams.get('zip');
        this.GetRepsFromZip()
      }
    })
  }

  ngAfterViewInit() {

    if (hbspt != 'undefined') {
      hbspt.forms.create({
        portalId: "46224302",
        formId: "a630d32e-177d-47df-ace8-2162dac48240",
        target: '#hubspotFindRepForm',
        cssClass: 'hubspotForm',
      });
    }

  }

  WorkYouMoFo(loc: any) {
    this.selectedWarehouse = [];
    this.selectedWarehouse = this.dotComService.warehouses.filter(z => z.name == loc.title)
  }

  ExploreByChanged(displayType: string) {
    this.exploreBy = displayType;
  }


  GetAllStates() {
    this.dotComService.GetAllStates().subscribe(data => {
      this.allStates = data;
    });
  }

  GetAllSegments() {
    this.allSegments = [];
    this.dotComService.GetAllSegments().subscribe(data => {
      this.allSegments = data;
    });
  }

  DisplayAllReps() {
    this.repsFilteredList = this.dotComService.repsMasterList;

    //clear the states checkboxes
    if (typeof document !== 'undefined') {
      const checkboxes = document.querySelectorAll('.stateCheckbox');
      checkboxes.forEach(checkbox => {
        (checkbox as HTMLInputElement).checked = false;
      });

      //clear the markets checkboxes
      const checkboxesMarkets = document.querySelectorAll('.marketsCheckbox');
      checkboxesMarkets.forEach(checkbox => {
        (checkbox as HTMLInputElement).checked = false;
      });

      this.checkedSegments = [];
      this.checkedStates = [];
    }
  }


  GetAllReps() {

    this.selectedMarket = "";
    this.selectedState = "";
    this.zipCode = "";
    this.repSearchText = "";
    this.displayMoreButton = true

    this.uncheckAllMarketsRadios();

    this.repsFilteredList = [];
    this.dotComService.GetAllReps(0).subscribe(data => {
      // if (data.length > 0) {
      this.dotComService.repsMasterList = data;

      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        element.FirstName = element.FirstName.toUpperCase()
        element.LastName = element.LastName.toUpperCase()
        element.email = element.email.toLowerCase()

        let x = element.Market;
        element.MarketArray = x.split(',');

        //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
        this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element.Id + ".jpg", (exists) => {
          if (exists) {
            // Success code
            //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
            element.empPhoto = this.employeePhotosImagePaths + element.Id + ".jpg";
          } else {
            // Fail code
            this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element.Id + ".png", (exists) => {
              if (exists) {
                // Success code
                element.empPhoto = this.employeePhotosImagePaths + element.Id + ".png";
              } else {
                // Fail code - use default
                element.empPhoto = this.baseImagePaths + "harrellsh.png"
              }
            })
          }
        });


        if (index < 12) {
          //only display 12 reps at a time
          this.repsRecordsInDisplayArray = index;
          this.repsFilteredList.push(element)
        }
      }
    });
  }

  removeItemsNotInSecondArray(arr1, arr2) {
    const emailsInArr2 = arr2.map(item => item.email);
    return arr1.filter(item => emailsInArr2.includes(item.email));
  }

  FilterRepsFired() {
    this.zipCode = "";
    this.dotComService.zipCodeEntered = "";
    this.repsFilteredList = [];
    this.repsFilteredListTotal = [];
    this.displayMoreButton = true;


    this.repsFilteredListTotal = this.dotComService.repsMasterList.filter(rep => {
      return rep.FirstName.toLowerCase().includes(this.repSearchText.toLowerCase())
        || rep.LastName.toLowerCase().includes(this.repSearchText.toLowerCase())
        || rep.email.toLowerCase().includes(this.repSearchText.toLowerCase())
        || rep.phone.toLowerCase().includes(this.repSearchText.toLowerCase().replaceAll('-',''))
    });

    //if market is also selected then filter by that too
    if (this.selectedMarket != "") {
      this.repsFilteredListTotal = this.repsFilteredListTotal.filter(rep => rep.Market.includes(this.selectedMarket));
    }

    // //if state is also selected then filter by that too
    if (this.selectedState != "") {
      //get reps by state

      this.checkedStates = [];
      this.checkedStates.push(this.selectedState);
      this.dotComService.GetRepsByState(this.checkedStates).subscribe(data => {

        //this 
        const filteredArray = this.removeItemsNotInSecondArray(this.repsFilteredListTotal, data);
        this.repsFilteredListTotal = filteredArray; //this.repsFilteredList.filter(rep => rep.State.includes(this.selectedState));
        this.repsFilteredListTotal.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1)
        this.repsFilteredList = this.repsFilteredListTotal.slice(0, 12); //only show 12 reps at a time
        this.repsRecordsInDisplayArray = this.repsFilteredList.length;

        if (this.repsFilteredListTotal.length == 0) {
          //no reps found for the  - add a default rep (jason frank) to the list
          this.AddDefaultRepresentativeIfNoneFound();
        }

      })
    }



    if (this.repsFilteredListTotal.length == 0) {
      //no reps found for the  - add a default rep (jason frank) to the list
      this.AddDefaultRepresentativeIfNoneFound();
    }
    else {
      //set repsfilteredlist = first 12 of repsFilteredListTotal
      this.repsFilteredListTotal.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1)
      this.repsFilteredList = this.repsFilteredListTotal.slice(0, 12); //only show 12 reps at a time
      this.repsRecordsInDisplayArray = this.repsFilteredList.length;
    }


    if (this.repsFilteredList.length < 12) {
      this.displayMoreButton = false;
    }




  }

  GetRepsFromZip() {
    this.displayFailure = false;
    if (this.zipCode.length != 5) {
      // alert("Please enter a valid 5 digit zip code");
      this.failureText = "Please enter a valid 5 digit zip code";
      this.displayFailure = true;
      // this.usersLocationdetected = false;
    } else {
      this.selectedState = "";
      this.dotComService.zipCodeEntered = this.zipCode;
      // this.dotComService.GetLatLonFromZip().subscribe(data => {
      this.dotComService.GetRepsFromZip().subscribe(data => {
        this.repsFilteredList = [];
        this.repsFilteredListTotal = [];
        this.displayMoreButton = true;

        if (data.length > 0) {

          //filter reps master list by the segments checked
          if (data.length > 0) {
            for (let indexcs = 0; indexcs < data.length; indexcs++) {
              const queryResult = data[indexcs];

              for (let index = 0; index < this.dotComService.repsMasterList.length; index++) {
                const rep = this.dotComService.repsMasterList[index];

                let x = rep.Market;
                rep.MarketArray = x.split(',');

                if (rep.email.toLowerCase().includes(queryResult.email.toLowerCase())) {

                  if (rep.Market.includes(this.selectedMarket)) {
                    //dont add the same rep twice
                    if (!this.repsFilteredListTotal.includes(rep))
                      this.repsFilteredListTotal.push(rep);
                  }
                }

                if (index == this.dotComService.repsMasterList.length - 1) {
                  if (this.selectedSort != "") {

                    this.MarketSortChanged()
                  }
                  else {
                    this.repsFilteredListTotal.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1)
                    this.repsFilteredList = this.repsFilteredListTotal.slice(0, 12); //only show 12 reps at a time
                    this.repsRecordsInDisplayArray = this.repsFilteredList.length;

                    if (this.repsFilteredListTotal.length < 12) {
                      this.displayMoreButton = false;
                    }

                  }
                }
              }
            }

            //go to this anchor in the middle of the page where the rep grid is
            this.viewportScroller.scrollToAnchor('jumpToAnchorReps');

            // this.usersLocationdetected = true;
            this.displayFailure = false;
            this.failureText = "";
          }
          else {
            this.AddDefaultRepresentativeIfNoneFound();
            this.displayMoreButton = false
          }
        }
        else {
          this.AddDefaultRepresentativeIfNoneFound();
          this.displayMoreButton = false
        }
      });
    }
  }

  GoToRepDetail(rep: any) {
    //navigate to the rep detail page
    this.router.navigateByUrl('/rep?id=' + rep.Id);
  }

  StateChanged(e: any) {
    this.displayMoreButton = true;
    this.zipCode = "";
    this.dotComService.zipCodeEntered = "";
    this.repsFilteredList = [];
    this.repsFilteredListTotal = []

    if (this.selectedState == "") {
      //no segments checked so show all reps
      this.repsFilteredListTotal = this.dotComService.repsMasterList;
      this.repsFilteredListTotal.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1)
    }
    else {
      this.checkedStates = [];
      this.checkedStates.push(this.selectedState);
      //passing in an array of states in case this goes back to accepting more than on 
      //state in the query 

      this.dotComService.GetRepsByState(this.checkedStates).subscribe(data => {

        //if a market is selected, filter by that too
        if (this.selectedMarket != "") {
          data = data.filter(rep => rep.Market.includes(this.selectedMarket));
        }

        //if search text is entered, filter by that too
        if (this.repSearchText != "") {
          data = data.filter(rep => {
            return rep.FirstName.toLowerCase().includes(this.repSearchText.toLowerCase())
              || rep.LastName.toLowerCase().includes(this.repSearchText.toLowerCase())
              || rep.email.toLowerCase().includes(this.repSearchText.toLowerCase())
              || rep.phone.toLowerCase().includes(this.repSearchText.toLowerCase())
          });
        }

        if (data.length == 0) {
          //no reps found for the  - add a default rep (jason frank) to the list
          this.AddDefaultRepresentativeIfNoneFound();
        }

        for (let index = 0; index < data.length; index++) {
          const rep = data[index];

          let x = rep.Market;
          rep.MarketArray = x.split(',');

          //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
          this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + rep.Id + ".jpg", (exists) => {
            if (exists) {
              // Success code
              //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
              rep.empPhoto = this.employeePhotosImagePaths + rep.Id + ".jpg";
            } else {
              // Fail code
              this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + rep.Id + ".png", (exists) => {
                if (exists) {
                  // Success code
                  rep.empPhoto = this.employeePhotosImagePaths + rep.Id + ".png";
                } else {
                  // Fail code - use default
                  rep.empPhoto = this.baseImagePaths + "harrellsh.png"
                }
              })
            }
          });

          //dont add the same rep twice
          if (!this.repsFilteredListTotal.includes(rep)) {
            this.repsFilteredListTotal.push(rep);
          }

          if (index == data.length - 1) {

            if (this.repsFilteredListTotal.length == 0) {
              //no reps found for the  - add a default rep (jason frank) to the list
              this.AddDefaultRepresentativeIfNoneFound();
            }

            this.repsFilteredListTotal.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1)
            this.repsFilteredList = this.repsFilteredListTotal.slice(0, 12); //only show 12 reps at a time
            this.repsRecordsInDisplayArray = this.repsFilteredList.length;
          }
        }
        if (this.repsFilteredListTotal.length < 12) {
          this.displayMoreButton = false;
        }
      });
    }
  }

  MarketRadioChanged(webSegment: string) {
    this.dotComService.GetAllReps(0).subscribe(repsMaster => {

      this.zipCode = "";
      this.dotComService.zipCodeEntered = "";
      this.repsFilteredList = [];
      this.repsFilteredListTotal = [];
      this.displayMoreButton = true;


      this.selectedMarket = webSegment;

      if (this.selectedMarket == "") {
        this.uncheckAllMarketsRadios();
      }
      else {
        (document.getElementById(webSegment) as HTMLInputElement).checked = true;
      }

      for (let index = 0; index < repsMaster.length; index++) {
        const rep = repsMaster[index];
        if (rep.Segment.includes(this.selectedMarket)) {

          let x = rep.Market;
          rep.MarketArray = x.split(',');

          //check to see if the image exists as a jpg, if not use png and then if neither exist the html will show a default image
          this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + rep.Id + ".jpg", (exists) => {
            if (exists) {
              // Success code
              rep.empPhoto = this.employeePhotosImagePaths + rep.Id + ".jpg";
            } else {
              // Fail code
              this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + rep.Id + ".png", (exists) => {
                if (exists) {
                  // Success code
                  rep.empPhoto = this.employeePhotosImagePaths + rep.Id + ".png";
                } else {
                  // Fail code - use default
                  rep.empPhoto = this.baseImagePaths + "harrellsh.png"
                }
              })
            }
          });

          this.repsFilteredListTotal.push(rep);
        }
        if (index == repsMaster.length - 1) {

          //if search text is entered, filter by that too
          if (this.repSearchText != "") {
            this.repsFilteredListTotal = this.repsFilteredListTotal.filter(rep => {
              return rep.FirstName.toLowerCase().includes(this.repSearchText.toLowerCase())
                || rep.LastName.toLowerCase().includes(this.repSearchText.toLowerCase())
                || rep.email.toLowerCase().includes(this.repSearchText.toLowerCase())
                || rep.phone.toLowerCase().includes(this.repSearchText.toLowerCase())
            });
          }
          //filter by state if selected

          if (this.selectedState != "") {
            //get reps by state
            this.checkedStates = [];
            this.checkedStates.push(this.selectedState);
            this.dotComService.GetRepsByState(this.checkedStates).subscribe(data => {

              //this removes any reps that is not assigned any entries in the ziprep table for the state selected
              const filteredArray = this.removeItemsNotInSecondArray(this.repsFilteredListTotal, data);
              this.repsFilteredListTotal = filteredArray; //this.repsFilteredList.filter(rep => rep.State.includes(this.selectedState));
              this.repsFilteredListTotal.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1)
              if (this.repsFilteredListTotal.length == 0) {
                //no reps found for the  - add a default rep (jason frank) to the list
                this.AddDefaultRepresentativeIfNoneFound();
              }
              else {
                this.repsFilteredList = this.repsFilteredListTotal.slice(0, 12); //only show 12 reps at a time
                this.repsRecordsInDisplayArray = this.repsFilteredList.length;

                if (this.repsFilteredListTotal.length < 12) {
                  this.displayMoreButton = false;
                }
              }
            })
          }
          else {
            this.repsFilteredListTotal.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1)
            this.repsFilteredList = this.repsFilteredListTotal.slice(0, 12); //only show 12 reps at a time
            this.repsRecordsInDisplayArray = this.repsFilteredList.length;

            if (this.repsFilteredListTotal.length < 12) {
              this.displayMoreButton = false;
            }

          }

          if (this.repsFilteredList.length == 0) {
            //no reps found for the  - add a default rep (jason frank) to the list
            this.AddDefaultRepresentativeIfNoneFound();
          }

        }
      }

      if (this.repsFilteredListTotal.length < 12) {
        this.displayMoreButton = false;
      }

    })
  }

  GetRepsFromCurrentLocation() {
    this.displayFailure = false;
    //get this locations zip then get the reps for that zip
    //if cant detect with location services (browser config says no bueno) user is prompted to enter zip code
    navigator.geolocation.getCurrentPosition((position) => {
      this.dotComService.GetLocationFromLatLon(position.coords.latitude, position.coords.longitude).subscribe(data => {
        if (data.results.length > 0) {
          for (let index = 0; index < data.results.length; index++) {
            const element = data.results[index];
            for (let indexR = 0; indexR < element.address_components.length; indexR++) {
              const elementR = element.address_components[indexR];
              if (elementR.types == "postal_code") {
                //populate the zip code in the zip code input box and trigger the submit button
                //this does the same thing as the user manually entering the zip code 
                this.zipCode = elementR.long_name;
                this.GetRepsFromZip()
                break;
              }
            }
          }
        }
        else {
          //should not have made it this far - zip not found in google result or the call failed
          //this.usersLocationdetected = true;
          this.displayFailure = true;
          this.failureText = "We were unable to determine your location. Please enter your zip code manually and press Submit.";
        }
      })
    }
      , (error) => {
        this.displayFailure = true;
        this.failureText = "We were unable to determine your location. Please make sure you have location services enabled on your browser.  Alternatively, you can enter your zip code manually and press Submit.";
      }
    );
  }

  GetDirections(warehouse: any) {
    window.open("https://www.google.com/maps/dir//" + warehouse.address + ", " + warehouse.city + ", " + warehouse.state + " " + warehouse.zip, "_blank");
  }

  GetDirectionsSelectedWarehouseFromMapMarker(warehouse: any) {
    window.open("https://www.google.com/maps/dir//" + warehouse[0].address + ", " + warehouse[0].city + ", " + warehouse[0].state + " " + warehouse[0].zip, "_blank");
  }

  //comment here 
  HideFailureAlert() {
    this.displayFailure = false;
  }

  uncheckAllMarketsRadios() {
    //clear the markets checkboxes
    if (typeof document !== 'undefined') {
      const checkboxesMarkets = document.querySelectorAll('.marketsCheckbox');
      checkboxesMarkets.forEach(checkbox => {
        (checkbox as HTMLInputElement).checked = false;
      });
    }
  }

  ToggleExpand(groupToExpand: string) {
    if (groupToExpand == "State") {
      this.stateExpanded = !this.stateExpanded;
      if (this.stateExpanded == false) {
        //group just collapsed and the checkboxes were set to unchecked = reload the grid
        //no segments checked so show all reps
        this.repsFilteredList = this.dotComService.repsMasterList;
        this.repsFilteredList.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1)
      }
    }
    else if (groupToExpand == "Market") {
      this.marketExpanded = !this.marketExpanded;
      if (this.marketExpanded == false) {
        //group just collapsed and the checkboxes were set to unchecked = reload the grid
        //no segments checked so show all reps
        this.repsFilteredList = this.dotComService.repsMasterList;
        this.repsFilteredList.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1)
      }
    }

  }

  MarketSortChanged() {

    if (this.selectedSort != "") {

      //order by marget selected, then by last name 
      //then by the remainder of reps who do not server that market in last name order

      let repsWithMarket = this.repsFilteredList.filter(z => z.Market.includes(this.selectedSort));
      let repsWithoutMarket = this.repsFilteredList.filter(z => !z.Market.includes(this.selectedSort));

      repsWithMarket.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1)
      repsWithoutMarket.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1)

      this.repsFilteredList = repsWithMarket.concat(repsWithoutMarket)

    }
    else {
      this.repsFilteredList.sort((a, b) => (a.LastName > b.LastName) ? 1 : -1)
    }
  }

  LoadMoreReps(): void {

    //if a filter is applied then we are loading all that apply for the filter 
    //no need to check to load any more 
    if (this.selectedMarket != "" || this.selectedState != "" || this.repSearchText != "") {
      //a filter is applied 
      for (var i = this.repsRecordsInDisplayArray; i < this.repsRecordsInDisplayArray + 12; i++) {
        if (this.repsFilteredListTotal[i]) {
          this.repsFilteredList.push(this.repsFilteredListTotal[i]);
        }
        else {
          this.displayMoreButton = false;
          break;
        }
      }
      this.repsRecordsInDisplayArray = this.repsRecordsInDisplayArray + 12;

    }
    else {
      //load more button fired - get another 12 if they are 12 left in the repsmasterlist array to get
      for (var i = 0; i < 12; i++) {
        if (this.repsFilteredList.length < this.dotComService.repsMasterList.length) {
          this.repsRecordsInDisplayArray = this.repsRecordsInDisplayArray + 1;
          this.repsFilteredList.push(this.dotComService.repsMasterList[this.repsRecordsInDisplayArray]);
        }
        else {
          this.displayMoreButton = false;
          break;
        }
      }
    }
  }

  sendEmail() {
    const recipient = 'contact@harrells.com';
    const subject = 'Harrells Find Your Rep';
    const body = "Hello, Would you please help me find my Harrell's representative? \n \n " +
      "First Name: " + this.firstNameRepMatch + " \n " +
      "Last Name: " + this.lastNameRepMatch + " \n " +
      "Company: " + this.companyRepMatch + " \n " +
      "Job Title: " + this.titleRepMatch + " \n " +
      "Phone: " + this.phoneRepMatch + " \n " +
      "Email: " + this.emailRepMatch + " \n " +
      "City: " + this.cityRepMatch + " \n " +
      "State: " + this.stateRepMatch + " \n " +
      "Zip: " + this.zipRepMatch + " \n \n " +
      "Golf: " + this.golfRepMatch.toString().replace('false', '').replace('true', 'Yes') + " \n " +
      "Horticulture: " + this.horticultureRepMatch.toString().replace('false', '').replace('true', 'Yes') + " \n " +
      "SportsTurf: " + this.sportsTurfRepMatch.toString().replace('false', '').replace('true', 'Yes') + " \n " +
      "SpecialtyAg: " + this.specialtyAgRepMatch.toString().replace('false', '').replace('true', 'Yes') + " \n " +
      "LawnCare: " + this.lawnCareRepMatch.toString().replace('false', '').replace('true', 'Yes') + " \n \n " +
      "Comments: " + this.commentsRepMatch + " \n "

    const mailtoUrl = `mailto:${recipient}?subject=${subject}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoUrl;

  }

  ToggleFilter() {
    this.showFilterObjects = !this.showFilterObjects;
  }

  AddDefaultRepresentativeIfNoneFound() {
    var element = this.dotComService.repsMasterList.filter(z => z.email == "jfrank@harrells.com");

    if (element.length > 0) {
      //check to see if the image exists as a jpg, if not use png and then if neither exist the html will show a default image
      this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element[0].Id + ".jpg", (exists) => {
        if (exists) {
          // Success code
          element[0].empPhoto = this.employeePhotosImagePaths + element[0].Id + ".jpg";
        } else {
          // Fail code
          this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element[0].Id + ".png", (exists) => {
            if (exists) {
              // Success code
              element[0].empPhoto = this.employeePhotosImagePaths + element[0].Id + ".png";
            } else {
              // Fail code - use default
              element[0].empPhoto = this.baseImagePaths + "harrellsh.png"
            }
          })
        }
      });
    }

    this.repsFilteredList.push(element[0]);
  }
}
